<template>
  <v-container class="pb-0" fluid>
    <v-row class="b-b align-center pt-3 pt-sm-0 navbar">
      <v-col cols="12" sm="2" class="pl-4 logo-container">
        <div class="logo" @click="$router.push('/admin')">
          <div class="logo-jobsin">JOBS IN</div>
          <div class="logo-region">Finland</div>
          <div class="logo-admin-badge">ADMIN</div>
        </div>
      </v-col>
      <NavigationDrawer />
    </v-row>
  </v-container>
</template>
<script>
import NavigationDrawer from '@/components/NavigationDrawer.vue';

export default {
  name: 'PositionSearch',
  components: {
    NavigationDrawer,
  },
};
</script>
<style scoped>
.logo {
  text-decoration: none;
  font-weight: 400;
  font-size: 24px;
  line-height: 1.05;
  letter-spacing: -2px;
  color: rgba(0, 45, 160, 1);
  display: flex;
  justify-content: left;
  align-items: center;
  height: 90%;
  flex-wrap: wrap;
  margin-bottom: 1em;
  position: relative;
  cursor: pointer;
}
.logo-region {
  font-weight: 600;
  text-transform: uppercase;
}
.logo-jobsin {
  padding-right: 0.3em;
}
.logo-admin-badge {
  background: rgba(0, 45, 160, 1);
  color: #fff;
  font-size: 0.5rem;
  position: fixed;
  top: 0;
  left: 0;
  letter-spacing: 0.2rem;
  padding: 0.3rem 0.5rem;
}
.navbar {
  height: 86px;
}

@media screen and (min-width: 1000px) {
  .logo {
    font-size: 20px;
  }
}

@media screen and (min-width: 1300px) {
  .logo {
    font-size: 28px;
  }
}

@media screen and (min-width: 600px) {
  .logo {
    margin-bottom: 0;
  }
}

@media screen and (max-width: 600px) {
  .logo-container {
    height: calc(75px - 11px);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    padding-bottom: 22px;
    margin-bottom: 12px;
  }
  .logo {
    margin-bottom: 0;
  }
  .navbar {
    height: auto;
  }
}
</style>
